// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'sharedComponents';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  text: {
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(5),
    padding: 0,
  },
}));

const VoidConfirmation = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();

  return (
    <Confirm
      classes={{ text: classes.text }}
      open={open}
      label="Void"
      text="Are you sure you want to void this order?"
      onClose={onClose}
      onConfirm={onConfirm}
      cancelLabel="Cancel"
    />
  );
};

VoidConfirmation.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default VoidConfirmation;
